export interface ParsedUserAgent {
  name: string;
  version: string;
  platform: string;
  userAgent: string;
  isSafari: boolean;
  isChrome: boolean;
}

const getPlatformFromUa = (uaLower: string): string => {
  if (uaLower.includes('windows')) return 'Windows';
  if (uaLower.includes('mac os')) return 'Mac';
  if (uaLower.includes('android')) return 'Android';
  if (uaLower.includes('iphone') || uaLower.includes('ipad') || uaLower.includes('ipod')) return 'iOS';
  if (uaLower.includes('linux')) return 'Linux';
  return 'Unknown';
};

const extractVersion = (uaLower: string, regex: RegExp): string => {
  const match = uaLower.match(regex);
  return match?.[1] ?? '';
};

export const parseUserAgent = (userAgent?: string): ParsedUserAgent => {
  const ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const uaLower = ua.toLowerCase();

  let name = 'Unknown';
  let version = '';

  if (uaLower.includes('edg/')) {
    name = 'Edge';
    version = extractVersion(uaLower, /edg\/([\d.]+)/);
  } else if (uaLower.includes('opr/')) {
    name = 'Opera';
    version = extractVersion(uaLower, /opr\/([\d.]+)/);
  } else if (uaLower.includes('chrome') || uaLower.includes('crios') || uaLower.includes('chromium')) {
    name = 'Chrome';
    version = extractVersion(uaLower, /(?:chrome|crios|chromium)\/([\d.]+)/);
  } else if (uaLower.includes('firefox') || uaLower.includes('fxios')) {
    name = 'Firefox';
    version = extractVersion(uaLower, /(?:firefox|fxios)\/([\d.]+)/);
  } else if (uaLower.includes('safari')) {
    name = 'Safari';
    version = extractVersion(uaLower, /version\/([\d.]+)/);
  }

  const isSafari = uaLower.includes('safari') && !/chrome|crios|chromium|edg|opr|fxios/.test(uaLower);
  const isChrome =
    (uaLower.includes('chrome') || uaLower.includes('crios') || uaLower.includes('chromium')) &&
    !/edg|opr/.test(uaLower);

  const platform =
    typeof navigator !== 'undefined' && navigator.platform ? navigator.platform : getPlatformFromUa(uaLower);

  return {
    name,
    version,
    platform,
    userAgent: ua,
    isSafari,
    isChrome,
  };
};

export const getBrowserInfo = (userAgent?: string) => parseUserAgent(userAgent);
